import { Card, Col, Row } from "react-bootstrap"

export default function LicensesDashboardCards({ licenses }) {

    return (

        <Row className="mb-4">

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Licenças Ativas</h6>
                        <h3>{licenses.filter(item => item.fgk_license_status == 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Licenças Expiradas/Revogadas</h6>
                        <h3>{licenses.filter(item => item.fgk_license_status !== 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body className="row">
                        <div className="col col-4">
                            <h6>Trials</h6>
                            <h3>{licenses.filter(item => item.fgk_license_type == 1).length}</h3>
                        </div>
                        <div className="col col-4">
                            <h6>Mensais</h6>
                            <h3>{licenses.filter(item => item.fgk_license_type == 2).length}</h3>
                        </div>
                        <div className="col col-4">
                            <h6>Anuais</h6>
                            <h3>{licenses.filter(item => item.fgk_license_type == 3).length}</h3>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Usuários Licenciados</h6>
                        <h3>{new Set(licenses.map(item => item.fgk_user)).size}</h3>
                    </Card.Body>
                </Card>
            </Col>

        </Row>

    )

}